define('plugin/invoice/view/InvoicePayNowButtonView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Invoice pay now button
     *
     * @class InvoicePayNowButtonView
     */
    return LayoutView.extend({

        template: '#invoice_pay_now_button_view',
        collectionEvents: {
            'sync': '_onSync'
        },

        childEvents: {
            'payment_processor:select': '_onSelectPaymentProcessor'
        },

        initialize: function() {
            LayoutView.prototype.initialize.apply(this);

            this._updatePaymentProcessorsSelected();
        },

        _onSync: function() {
            this._updatePaymentProcessorsSelected();
            this.render();
        },

        _updatePaymentProcessorsSelected: function () {
        }

    });

});
